module.exports = __webpack_public_path__ + "static/img/stimulusConfigBlue.16d7e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stimulusConfigBlue.png
// module id = SsbZ
// module chunks = 1